// ReSharper disable InconsistentNaming
// ReSharper disable UseOfImplicitGlobalInFunctionScope

var HomeSlick = require("./controls/homeslick");
var InputNumber = require("./controls/inputNumber");
var MainMenu = require("./controls/mainMenu");
var WishlistService = require("./controls/wishlist/wishlist.service");
var SearchBox = require("./controls/search-box.component");
var CollapsiblePanelsService = require("./controls/collapsible-panel/collapsible-panels.service");
var CollapsibleTextService = require("./controls/collapsible-text/collapsible-text.service");
var NewsSubscriptionService = require("./controls/news-subscription/news-subscription.service");
var CookiesService = require("./services/cookies.service");

function PcgFrontend() {
    this.init = function() {
        $.pcg = $.pcg || {};
        $.pcg.frontend = $.pcg.frontend || {};

        $.extend($.pcg.frontend, {
            collapsiblePanelsService: new CollapsiblePanelsService(),
            collapsibleTextService: new CollapsibleTextService(),
            cookiesService: CookiesService,
            homeSlick: HomeSlick,
            inputNumber: InputNumber,
            mainMenu: new MainMenu(),
            newsSubscriptionService: new NewsSubscriptionService(),
            searchBox: new SearchBox(),
            wishlistService: new WishlistService(),
        });
    };
}

module.exports = new PcgFrontend();
